import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';


const RequestFullDetermination = ({ 
    exchangeName, 
    exchangeMedicaid,
    defaultExchangeMedicaid,
    toggleEnabled, 
    onSubmitCb, 
    fullDeterminationSubmitted, 
    link, 
    medicalAssistanceLink,
    medicalAssistanceTefraLink 
}) => {
    const [contentCollapsed, toggle] = useState(toggleEnabled);

    const toggleContent = (e) => {
        e.preventDefault();
        toggle(!contentCollapsed);
    };

    return (
        <div className="request-determination">
            { fullDeterminationSubmitted ?
                <FormattedMessage id="eligibility_results.request_determination_submitted" tagName="p"/> :

                <Fragment>
                    <FormattedMessage
                        id="eligibility_results.request_determination_p1"
                        tagName="p"
                        values={{
                            exchangeName,
                            br: <br />,
                        }}
                    />
                    { toggleEnabled &&
                    <p className="request-determination__toggle">
                        <FormattedMessage
                            id="eligibility_results.request_determination_toggle"
                            values={{
                                secondPart:
                                    <a id="requrestDeterminationToggle"
                                        onClick={toggleContent}
                                        href="#">
                                        <FormattedMessage id="common.click_here"/>
                                    </a>
                            }}
                        />
                    </p>
                    }
                    { !contentCollapsed &&
                    <div className="request-determination__content">
                        <FormattedMessage id='eligibility_results.request_determination_expanded' 
                            tagName='p' 
                            values={{
                                exchangeName,
                                exchangeMedicaid,
                                defaultExchangeMedicaid,
                                a1: chunks => <a className="usa-link--external" target="_blank" rel="noopener noreferrer" href={medicalAssistanceLink}>{chunks}</a>,
                                a2: chunks => <a className="usa-link--external" target="_blank" rel="noopener noreferrer" href={medicalAssistanceTefraLink}>{chunks}</a>,
                                link, 
                                lineBreak: <br/>
                            }}
                        />
                        <Button
                            id='eligibilityRequestFullDetermination'
                            className='usa-button usa-button--outline gi-button gi-button__outline eligibility_CTA'
                            onClick={onSubmitCb}
                        >
                            <FormattedMessage
                                id='button.request_full_determination'
                                values={{
                                    defaultExchangeMedicaid
                                }}
                            />
                        </Button>
                    </div>
                    }
                </Fragment>
            }
        </div>
    );
};

export default RequestFullDetermination;